import OutdoorIcon from "../../assets/product-list-assets/wifi-outdoor.svg";
import type { ProductListGroup } from "../../types";

export const wifiOutdoor: ProductListGroup = {
  id: "outdoor",
  title: "productListGroup.wifiOutdoor.title",
  icon: {
    src: OutdoorIcon,
    width: 16,
    height: 19,
  },
};
